class IndividualProductDetailImages extends ProductDetailImages {
    constructor(el) {
        super(el);

        const pictureElement = el.querySelector(".ProductDetailImages-mainSlider picture");
        const webpSourceElement = pictureElement.querySelector('source[type="image/webp"]');
        const imgElement = pictureElement.querySelector('img');

        this.imageSources = VueReactivity.reactive({
            img: imgElement.src ?? null,
            webp: webpSourceElement.srcset ?? null,
        });
        VueReactivity.watch(this.imageSources, () => {
            if (this.imageSources.img) {
                imgElement.src = this.imageSources.img;
            }
            if (this.imageSources.webp) {
                webpSourceElement.srcset = this.imageSources.webp;
            }
        }, {immediate: true});
    }

    onVariantChanged(variant) {
        // S ohledem na feature pro přepínání obrázků u baravných alternativ, tuto funkci deaktivujeme. Klient nepoužívá varianty ale barevné alternativy a alternativní velikosti produktů.
    }

    /**
     * @param {ColorVariantOverlayImage} overlayImage
     */
    onSwitchImage(overlayImage) {
        this.imageSources.img = overlayImage.overlayImage;
        this.imageSources.webp = overlayImage.webpOverlayImage;
    }

    init() {
        super.init();
        EventBus.getInstance().addEventListener('productColorVariantHovered', e => this.onSwitchImage(e.detail));
    }
}
